/**
 * The campaigns the library's AI wizard can read stats from: the config rows
 * whose tracker the library API accepts (libraryProviderOf), in the rows' order, with the provider already narrowed.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FlowOptimizerLibraryProvider, TrackerId } from '@trafficpulse/shared';

import { libraryProviderOf } from '@/features/trackers/flow-optimizer/library-provider';

interface ConfigRowLike {
  provider: TrackerId;
  campaignId: string;
  campaignName: string;
}

export interface LibraryTarget {
  provider: FlowOptimizerLibraryProvider;
  campaignId: string;
  campaignName: string;
}

export function libraryTargets(rows: readonly ConfigRowLike[]): LibraryTarget[] {
  return rows.flatMap(({ provider, campaignId, campaignName }) => {
    const library = libraryProviderOf(provider);
    return library ? [{ provider: library, campaignId, campaignName }] : [];
  });
}

/** The first row the wizard can use (today's `rows[0]` for Voluum/Binom). */
export function firstLibraryTarget(rows: readonly ConfigRowLike[]): LibraryTarget | null {
  return libraryTargets(rows)[0] ?? null;
}

/** Picker value of a campaign: `provider:campaignId`. */
export function libraryTargetKey(target: { provider: string; campaignId: string }): string {
  return `${target.provider}:${target.campaignId}`;
}

export function findLibraryTarget(
  targets: readonly LibraryTarget[],
  key: string,
): LibraryTarget | null {
  return targets.find((target) => libraryTargetKey(target) === key) ?? null;
}
